import { shuffle } from 'lodash-unified';
import { ClassicGameDefinition } from '@bg-shared/utils/ClassicGameDefinition';
import { ILotteryItem } from '@bg-shared/interfaces/ILotteryItem';
import { GameId } from '@bg-shared/enums/GameId';
import { RED_BLUE_COLORS_ORDER } from '@bg-shared/constants/constants';

export const createRandomLotteryItems = (
    gameId: GameId,
    count: number,
    lotteryItems: ILotteryItem[],
): ILotteryItem[] => {
    let items = [];

    if (ClassicGameDefinition.isWithSectors(gameId)) {
        for (let i = 0; i < count; i++) {
            const randomIndex = Math.floor(Math.random() * lotteryItems.length);
            const randomItem = lotteryItems[randomIndex];
            const color = ClassicGameDefinition.isDiceDuel(gameId)
                ? RED_BLUE_COLORS_ORDER[i]
                : randomItem.color;

            items.push({
                ...randomItem,
                color,
            });
        }
    } else {
        items = shuffle([...lotteryItems]).slice(0, count);
    }

    return items;
};
